"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ShadowProfileModel", {
    enumerable: true,
    get: function() {
        return ShadowProfileModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const ShadowProfileModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    active_assigned_goal_count: _zod.z.number(),
    author_of_review_count: _zod.z.number(),
    company: _zod.z.instanceof(_bson.ObjectId),
    completed_todo_count: _zod.z.number(),
    direct_report_count: _zod.z.number(),
    feedback_received_count: _zod.z.number(),
    feedback_sent_count: _zod.z.number(),
    last_refresh: _zod.z.date(),
    permission_level: _zod.z.enum([
        "admin",
        "billing admin",
        "employee",
        "basic admin"
    ]),
    signer_of_review_count: _zod.z.number(),
    subject_of_review_count: _zod.z.number(),
    total_assigned_goal_count: _zod.z.number(),
    user: _zod.z.instanceof(_bson.ObjectId)
});
